var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.376 27.741l.162 21.32m-.162-21.32l11.216-12.525M30.376 27.741L19.83 16.371m10.708 32.69l8.513 3.96-17.742-.125 9.23-3.835zm11.054-33.845l4.245-4.74-31.189.308 5.183 5.587m21.762-1.155c-1.524.145-6.251 2.861-9.846 1.493s-8.104-3.606-11.916-.338",
    stroke: "currentColor",
    strokeWidth: 1.497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.531 3.386a.75.75 0 00-.143-1.049.75.75 0 00-1.049.143l1.192.906zM29.598 20.561a.75.75 0 00.143 1.049.75.75 0 001.049-.143l-1.192-.906zM43.339 2.48L29.598 20.561l1.192.906L44.531 3.386l-1.192-.906z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.196,
    cy: 17.291,
    r: 3.179
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MSIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDYxIDYwIiBmaWxsPSJub25lIiB4bWxuczp2PSJodHRwczovL3ZlY3RhLmlvL25hbm8iPjxwYXRoIGQ9Ik0zMC4zNzYgMjcuNzQxbC4xNjIgMjEuMzJtLS4xNjItMjEuMzJsMTEuMjE2LTEyLjUyNU0zMC4zNzYgMjcuNzQxTDE5LjgzIDE2LjM3MW0xMC43MDggMzIuNjlsOC41MTMgMy45Ni0xNy43NDItLjEyNSA5LjIzLTMuODM1em0xMS4wNTQtMzMuODQ1bDQuMjQ1LTQuNzQtMzEuMTg5LjMwOCA1LjE4MyA1LjU4N20yMS43NjItMS4xNTVjLTEuNTI0LjE0NS02LjI1MSAyLjg2MS05Ljg0NiAxLjQ5M3MtOC4xMDQtMy42MDYtMTEuOTE2LS4zMzgiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNDk3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik00NC41MzEgMy4zODZhLjc1Ljc1IDAgMCAwLS4xNDMtMS4wNDkuNzUuNzUgMCAwIDAtMS4wNDkuMTQzbDEuMTkyLjkwNnpNMjkuNTk4IDIwLjU2MWEuNzUuNzUgMCAwIDAgLjE0MyAxLjA0OS43NS43NSAwIDAgMCAxLjA0OS0uMTQzbC0xLjE5Mi0uOTA2ek00My4zMzkgMi40OEwyOS41OTggMjAuNTYxbDEuMTkyLjkwNkw0NC41MzEgMy4zODZsLTEuMTkyLS45MDZ6Ii8+PGNpcmNsZSBjeD0iMzMuMTk2IiBjeT0iMTcuMjkxIiByPSIzLjE3OSIvPjwvZz48L3N2Zz4=";
export { SvgIconBar as ReactComponent };